var createStylesheet = function(chunkId, fullhref, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	2143: 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"8":1,"45":1,"411":1,"521":1,"540":1,"577":1,"626":1,"777":1,"863":1,"1035":1,"1041":1,"1325":1,"1363":1,"1654":1,"1657":1,"1690":1,"1711":1,"1714":1,"1715":1,"1913":1,"1938":1,"2193":1,"2198":1,"2240":1,"2343":1,"2357":1,"2390":1,"2468":1,"2472":1,"2489":1,"2586":1,"2599":1,"2638":1,"2734":1,"2746":1,"2852":1,"2941":1,"3294":1,"3505":1,"3565":1,"3587":1,"3629":1,"3826":1,"3879":1,"3880":1,"3907":1,"3937":1,"3968":1,"3979":1,"4046":1,"4117":1,"4293":1,"4359":1,"4402":1,"4425":1,"4533":1,"4774":1,"4791":1,"4891":1,"5041":1,"5159":1,"5363":1,"5366":1,"5452":1,"5577":1,"5578":1,"5666":1,"5796":1,"5797":1,"5844":1,"5928":1,"5935":1,"6105":1,"6112":1,"6262":1,"6495":1,"6505":1,"6643":1,"6864":1,"6889":1,"6910":1,"7017":1,"7046":1,"7105":1,"7127":1,"7768":1,"7858":1,"7929":1,"8111":1,"8132":1,"8149":1,"8213":1,"8765":1,"8882":1,"9009":1,"9034":1,"9244":1,"9317":1,"9402":1,"9473":1,"9497":1,"9518":1,"9755":1,"9828":1,"9855":1,"9882":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr